import { render, staticRenderFns } from "./ministry-users.vue?vue&type=template&id=4899bb5b&scoped=true&"
import script from "./ministry-users.vue?vue&type=script&lang=js&"
export * from "./ministry-users.vue?vue&type=script&lang=js&"
import style0 from "./ministry-users.vue?vue&type=style&index=0&id=4899bb5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899bb5b",
  null
  
)

export default component.exports